// Source of truth for STAGING's Cognito/API Gateway values.
//
// Not imported directly by app code - `select-config.sh staging` (run
// automatically by `npm run build:staging`) copies this file's contents
// into aws-config.js, the file the app actually imports. Editing
// aws-config.js by hand instead of editing this file is how staging and
// production values got mixed up in the past (see CLAUDE.md's dashboard
// CORS/"failed to fetch" entries) - always edit the per-environment file,
// never aws-config.js directly.
//
// Regenerate these values from the staging stack's own outputs if they
// ever change:
//
//   AWS_PROFILE=innovation-uat aws cloudformation describe-stacks \
//     --stack-name instapay-router-callback-dashboard-staging \
//     --query "Stacks[0].Outputs"
//
export const awsConfig = {
  region: 'ap-southeast-1',
  userPoolId: 'ap-southeast-1_bzFgooVqW',
  userPoolClientId: '2oau57n3apa8fp1ls2at7c5ug5',
  apiBaseUrl: 'https://6n51t49ey9.execute-api.ap-southeast-1.amazonaws.com/staging',
};
